import { Component, computed, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { CartStateService } from '../../state/cart.state';
import { CartItem } from '../../models/pedido.models';
import { PermisosService } from '../../../../core/auth/permisos.service';

@Component({
  selector: 'app-cart-drawer',
  standalone: true,
  imports: [],
  templateUrl: './cart-drawer.html',
})
export class CartDrawer {
  private router = inject(Router);
  cartState = inject(CartStateService);
  permisos = inject(PermisosService);

  isOpen = input<boolean>(false);
  onClose = output<void>();

  items = this.cartState.items;
  totalItems = this.cartState.totalItems;
  totalMateriales = this.cartState.totalMateriales;
  totalEquipos = this.cartState.totalEquipos;
  isEmpty = this.cartState.isEmpty;
  hasMixedSectors = this.cartState.hasMixedSectors;

  materialesItems = computed(() =>
    this.items().filter((i) => i.tipo === 'MATERIAL')
  );

  equiposItems = computed(() =>
    this.items().filter((i) => i.tipo === 'EQUIPO')
  );

  close() {
    this.onClose.emit();
  }

  removeItem(item: CartItem) {
    this.cartState.removeItem(item.tipo, item.recurso_id);
  }

  updateCantidad(item: CartItem, delta: number) {
    const newCantidad = item.cantidad + delta;
    if (newCantidad >= 1) {
      this.cartState.updateCantidad(item.tipo, item.recurso_id, newCantidad);
    }
  }

  clearCart() {
    this.cartState.clearCart();
  }

  procederAlPedido() {
    this.close();
    this.router.navigate(['/pedido/create']);
  }
}
